import React, { useState } from "react";
import GoogleIcon from "../../../css/images/icon-google.svg";
import { Link } from "react-router-dom";
import Features from "./Features";

const SignupScreen = ({ googleSignIn, emailSignUp }) => {
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");

	const handleSignup = (event) => {
		event.preventDefault();
		// Handle signup form submission
		// console.log("Signup form submitted:", { firstName, lastName, email, password });
		emailSignUp(email, password);
	};

	return (
		<div className="signup-container">
			<div className="info-container">
				<Features />
			</div>
			<div className="form-container">
				<h1 className="signup-title">Sign Up</h1>
				<form onSubmit={handleSignup} className="signup-form">
					<div className="input-group name-group">
						<div className="name-inputs">
							<label className="signup-label">First Name:</label>
							<input type="text" value={firstName} onChange={(event) => setFirstName(event.target.value)} className="signup-input first" />
						</div>
						<div className="name-inputs">
							<label className="signup-label last">Last Name:</label>
							<input type="text" value={lastName} onChange={(event) => setLastName(event.target.value)} className="signup-input last" />
						</div>
					</div>
					<div className="input-group">
						<label className="signup-label">Email:</label>
						<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} className="signup-input" />
					</div>
					<div className="input-group">
						<label className="signup-label">Password:</label>
						<input type="password" value={password} onChange={(event) => setPassword(event.target.value)} className="signup-input" />
					</div>
					<button type="submit" className="signup-button">
						Sign Up
					</button>
				</form>
				<div className="sep-wrp">
					<h3 className="sep-title">OR</h3>
				</div>
				<button className="btn-google-login" onClick={() => googleSignIn()}>
					<span className="ico">
						<img src={GoogleIcon} className="icon-google" alt="icon-google" />
					</span>
					<span className="txt">Sign up with Google</span>
				</button>
				<div className="toggle-login">
					Already have an account?
					<Link to="/login" className="login-link">
						Login
					</Link>
				</div>
			</div>
		</div>
	);
};

export default SignupScreen;
